import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent {
  @Input() formGroup!: FormGroup;
  @Input() documentNumberForm: any[] = [];
  @Input() metaData: any[] = [];
  @Input() daysMonths: any[] = [];
  @Input() prasentYear: number = new Date().getFullYear();
  @Input() ddmmyyyyy: any;
  @Input() ddmmyy: any;
  @Input() showErrorMessage: () => string = () => '';
  @Input() getradioValue: (value: any, metaData: any, id: any) => boolean = () => false;
  @Input() selectedFile: any;
  @Input() uploadingFile: any;
  @Input() metaDataLength: number = 0;
  @Input() documentNumber: string = '';
  @Input() documentNameFromBarcodes: string = '';
  @Input() isloadingIcon: boolean = false;
  @Input() ocrLoading: boolean = false;
  @Input() faEllipsis: any;
  @Input() showError: boolean = false;
  @Input() scanDisabled: boolean = false;
  @Input() companyPrefs: any;
  @Input() scannerLicence: any;
  @Input() enableWorkFlow: boolean = false;
  @Input() selectedFolderPath: string = '';
  @Input() selectedFolderId: any;
  @Input() parentDirectoryId: any;
  @Input() workflowList: any[] = [];
  @Input() seletedWorkflow: any;
  @Input() selectedWorkflowId: any;
  @Input() documentType: any;
  @Input() folderSelection: boolean = false;
  @Input() faFile: any;
  @Input() faCloudUploadAlt: any;
  @Input() faTrash: any;
  @Input() faCopy: any;
  @Input() faSpinner: any;
  @Input() faInfoCircle: any;
  @Output() handleDocumentTypeChange = new EventEmitter<{ value: any, id: any }>();
  @Output() openFolderSelection = new EventEmitter<any>();
  @Output() onSelectWorkflow = new EventEmitter<any>();
  @Output() selectedFolderEmit = new EventEmitter<any>();
}
